/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { RouteUtils as CoreRouteUtils } from "abweb/utils/RouteUtils";
export class RouteUtils {
  constructor() {
    // static class only
  }
  static getReqParamAsString(routeParams, paramName) {
    return CoreRouteUtils.getReqParamAsString(routeParams, paramName);
  }
  static getOptParamAsString(routeParams, paramName, defaultVal) {
    return CoreRouteUtils.getOptParamAsString(routeParams, paramName, defaultVal);
  }
  static getExtraParamAsString(routeParams, paramName, defaultVal) {
    return CoreRouteUtils.getExtraParamAsString(routeParams, paramName, defaultVal);
  }
  static getReqParamAsNumber(routeParams, paramName) {
    return CoreRouteUtils.getReqParamAsNumber(routeParams, paramName);
  }
  static getOptParamAsNumber(routeParams, paramName, defaultVal) {
    return CoreRouteUtils.getOptParamAsNumber(routeParams, paramName, defaultVal);
  }
  static getExtraParamAsNumber(routeParams, paramName, defaultVal) {
    return CoreRouteUtils.getExtraParamAsNumber(routeParams, paramName, defaultVal);
  }
  static getReqParamAsBoolean(routeParams, paramName) {
    return CoreRouteUtils.getReqParamAsBoolean(routeParams, paramName);
  }
  static getOptParamAsBoolean(routeParams, paramName, defaultVal) {
    return CoreRouteUtils.getOptParamAsBoolean(routeParams, paramName, defaultVal);
  }
  static getExtraParamAsBoolean(routeParams, paramName, defaultVal) {
    return CoreRouteUtils.getExtraParamAsBoolean(routeParams, paramName, defaultVal);
  }

  /**
   * @return anchor fragment of url (aka href), which holds the route.
   * Returns null if the url does not have an anchor fragment, or if the fragment (aka route) is empty.
   */
  static getRouteFromUrl(url) {
    if (url) {
      const anchorIndex = url.indexOf("#");
      if (anchorIndex >= 0 && anchorIndex < url.length - 1) {
        return url.substring(anchorIndex + 1);
      }
    }
    return null;
  }

  // static getRouteProps<PropsT extends {} = any>(route: IRoute): PropsT {
  //   const regRoute = NavigationService.getSingleton().getRegisteredRouteOrError(route.route);
  //   return regRoute.routeSpec.routeParamHandler?.propsFromParams({
  //         routeParams: route.routeParams,
  //         routeExtraParams: route.routeExtraParams,
  //       })
  //       ?? {};
  // }
}
//# sourceMappingURL=RouteUtils.js.map
